import { useLocation } from 'react-router';

const useLocationState = <T>() => {
  const location = useLocation();
  return location.state as T;
};

export default useLocationState;
